/* eslint-disable */
/* tslint:disable */

import { Pagination } from 'antd';
import moment from 'moment';
import { useEffect, useState } from 'react';
import Dialog from '../../../components/dialog/dialog';
import { getEnv } from '../../../helpers/mobx-easy-wrapper';

const newsList = [{}, {}, {}];

export interface NoticeItem {
  id: string;
  title: string;
  author: string;
  content: string;
  creator: string;
  publishAt: string;
  summary: string;
  thumbnail: string;
  video: string;
  hasExternalUrl: Boolean;
  externalUrl: string;
}
export interface NoticeResponse {
  items: Array<NoticeItem>;
  totalItems: number;
  totalPages: number;
}

const Notice = () => {
  const [showDialog, setShowDialog] = useState(false);
  const [pageNo, setPageNo] = useState(1);
  const [category, setCategory] = useState('公告');
  const [data, setData] = useState<Array<NoticeItem>>();
  const [totalPage, setTotalPage] = useState(1);
  const [totalNums, setTotalNums] = useState(1);
  const [dialogItem, setDialogItem] = useState<NoticeItem>();

  const nextPage = () => {
    window.scrollTo(0, 0);
    if (pageNo < totalPage) {
      setPageNo(pageNo + 1);
    }
  };

  const prevPage = () => {
    if (pageNo > 1) {
      setPageNo(pageNo - 1);
    }
  };

  // empty array as second argument equivalent to componentDidMount
  useEffect(() => {
    const { apiFactory } = getEnv();
    async function fetchData() {
      const response = await apiFactory.activityService.getNoticeData(
        pageNo,
        category
      );
      setTotalPage(response.totalPages);
      setTotalNums(response.setTotalNums);
      setData(response.items);
    }
    fetchData();
  }, [pageNo, category]);

  return (
    <div className="home" style={{ minHeight: '600px' }}>
      {/*<Banner />*/}
      <div className="jury__line outlineTitle" style={{ textAlign: 'center' }}>
        <label
          className={`enter_label  ${category === '公告' ? 'active' : ''}`}
          onClick={() => (setCategory('公告'), setPageNo(1))}
        >
          公告
        </label>
        <div className={`split__line`}></div>
        <label
          className={`enter_label  ${category === '新闻' ? 'active' : ''}`}
          onClick={() => (setCategory('新闻'), setPageNo(1))}
        >
          新闻
        </label>
        {/* <div className={`split__line`}></div>
        <label
          className={`enter_label  ${category === '活动专区' ? 'active' : ''}`}
          onClick={() => (setCategory('活动专区'), setPageNo(1))}
        >
          活动专区
        </label> */}
        {/* <div className={`split__line`}></div>
        <label
          className={`enter_label  ${
            category === '上技会客厅' ? 'active' : ''
          }`}
          onClick={() => (setCategory('上技会客厅'), setPageNo(1))}
        >
          上技会客厅
        </label> */}
      </div>

      {showDialog && (
        <Dialog
          onClose={() => {
            setShowDialog(false);
          }}
        >
          <div className="fullDialog">
            <div
              className="closeIcon"
              onClick={() => {
                setShowDialog(false);
              }}
            ></div>
            <div className="dialogTitle">{dialogItem?.title}</div>
            <div className="dialogTime">
              {' '}
              {moment(dialogItem?.publishAt).format('YYYY年MM月DD日')}
            </div>
            <div
              className="dialogContent"
              dangerouslySetInnerHTML={{ __html: dialogItem!.content }}
            ></div>
            <div>
              {/*<div className="dialogImg">
                <img src={dialogItem?.thumbnail} />
              </div>*/}
              <div className="buttonArea">
                <button
                  className="closeButton"
                  onClick={() => {
                    setShowDialog(false);
                  }}
                >
                  关闭
                </button>
              </div>
            </div>
          </div>
        </Dialog>
      )}

      <ul className="notice-div-container">
        {data?.map((item, index) => {
          return (
            <li
              key={index}
              onClick={() => {
                const hasExternalUrl = item.hasExternalUrl || false;
                if (hasExternalUrl) {
                  window.open(item.externalUrl, '_blank');
                } else {
                  setDialogItem(item);
                  setShowDialog(true);
                }
              }}
            >
              <div className="notice-div-content">
                <div className="notice-date">
                  {(item as NoticeItem).title} /{' '}
                  {moment(item.publishAt).format('YYYY年MM月DD日')}
                </div>
                <div className="notice-summary">
                  {(item as NoticeItem).summary}
                </div>
              </div>

              <div className="notice-div-img">
                <img src={(item as NoticeItem).thumbnail} />
              </div>
            </li>
          );
        })}
      </ul>

      <div className="pagination">
        {totalPage > 1 && (
          <Pagination
            current={pageNo}
            onChange={setPageNo}
            total={totalNums}
            showSizeChanger={false}
          />
        )}
        {/*  <div
          className="pagination__item"
          style={{ width: "72px" }}
          onClick={prevPage}
        >
          {" "}
          <div className="leftArrow"></div>上一页
        </div>
        {[...Array(totalPage)].map((item, i) => {
          return (
            <div
              key={i + "page"}
              className={`${
                pageNo == i + 1 ? "pagination__item active" : "pagination__item"
              }`}
              onClick={() => {
                setPageNo(i + 1);
              }}
            >
              {i + 1}
            </div>
          );
        })}
                <div className="pagination__item">1</div>
        <div className="pagination__item">2</div>
        <div className="pagination__item">3</div>
        <div className="pagination__item">4</div>
        <div className="pagination__item">5</div>
        <div
          className="pagination__item"
          style={{ width: "72px" }}
          onClick={nextPage}
        >
          下一页<div className="rightArrow"></div>
        </div>*/}
      </div>
    </div>
  );
};

export default Notice;
